import { render } from "./matched-talents-page.vue?vue&type=template&id=730d28c8&ts=true"
import script from "./matched-talents-page.vue?vue&type=script&lang=ts"
export * from "./matched-talents-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__